import React, {useState, useEffect, useCallback, useMemo, useRef} from "react";
import caretActive from "./images/caret-active.svg";
import caretInactive from "./images/caret-inactive.svg";
import closeIcon from "./images/close.svg";

import wrs from "./images/logo.png";
import marker from "./images/marker.svg";

import plotigoLogo from "./images/plotigo-logo.svg";
import wtLogo from "./images/wt-logo.png";
import exclamation from "./images/exclamation.png";

import moment from "moment";
import _, {filter} from "lodash";
import {Provider} from "react-redux";
import configStore from "./redux/configStore";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import polyline from "polyline";
import {getDateByNTP} from "./tools/getNtp";
import GoogleMapReact from "google-map-react";
import debugLog, {LogLevel} from './utils/debugLog';

import {
  updateBusLocation,
  getBusETA,
  updateEta,
  shouldUpdateData,
  getRouteTags,
  getAllEta,
  getAllEtaSuccess,
  setNtp,
  setNtpSuccess,
  getAllAssignment,
} from "./redux/action";

import {colors} from "./colors";
import "./App.css";
import signalrService from "./services/signalrService";

// Hardcoded map 
// Use base64 + https://developers.google.com/maps/documentation/utilities/polylineutility for encode/decode 
const weekdayCenterLocation = {
  lat: 1.3340667801565174,
  lng: 103.9660560917981,
}
const weekendCenterLocation = {
  lat: 1.3459549053267472,
  lng: 103.96538328495923,
}
const weekdayZoom = 16;
const weekendZoom = 14;
const weekdayRoute = "e3JjR19icHlSXlBMSEREQEZGSEBOP0hBSEFGSkZKREpGSkRIREhEXFBCQkBBTmdAZEBhQm5AZ0NiQGdCcEBlQ3pAcURgQWtDaEB7QkRXUl1gQHtCbkF1RWRAaUJKZ0BBZ0BDVVtnQFlRXU1tQ2tBX0FjQGFFX0NtQ3NBZUNvQW9DfEV5Q3BGZ0RqR2VCckN6QGRAbENwQWJBdkB0QGBAekBQYkBBYkBBfEA/dEBaWFhQZkBKaEA/VklmQF1sQGdAXGtAUHFAP2VAQmNAVFNWcUBqQWlAaEFVYkBDWkhcYkBabEN0QXRBcEBIQkxDSElORWpAVg==";
const weekendRoute = "d3JjR19icHlSUEZeWkhUP05BSkFGVk5QSlpOVExKREBBSF9AUGtAUnVAUndATm1AVH1AUG9AbEBlQ2JAYUJqQGFDQkl4QG9CZkB1QkVRX0RfQnVCZUFrQXVAd0F5QGNBbUB3QXtAd0F3QGlBc0BtQXNAeUF3QGdCZUFjQ3lBbUJnQWdCYUFfQ3VBbUBdb0BTeUBJbUA/bUBIa0BadUB0QGdBZkFRTFtOZ0F0QHVDYEJ9QmpBe0NkQndCakFxQ2hCeUNqQmVCZkF5QnBCc0B2QH1AdkFlQGZBW2xBR2BAQHpAQnZAVWhAZUBgQG9AWG9ASXdBWWlCXWtATW9AQWtAP3dCQW1CQ31CRF9ATWFAZUJrQmlKcUFhR3dAY0J3QG9AY0JrQHdDbUBrR2NBa0dfQX1BXV9AR1tkQk12QFl4QUVeRmpAQlpDXl12QllsQlN0QVdgQlNuQU18QHhAUnpAUH5BUHJAP3hAQnBARWZAS3RBWXZAWXZDY0FwQ2VBfkBfQFpRWGFAbEBlQlRxQFphQFpRdEJbckBPXnJBdkBsRVp6QWhAfkJiQGRBVmBAcEE/aERKbENSfER0QH5FYEF0RHZAfkZqQW5EdkB8S2JDfkZ+QHZKakJgRHRAdEVsQnRDZkJUP1xDVkVkQWVCfEF3Q25BeUJyQGlBckBpQWRBZkBmQFxSTUhLVEReUA==";
const googleMapsApi = "AIzaSyDYGvy_HvsUfvJ_7_d4PmOH201jIFNn-iM";

// Stores & Imports
const {store} = configStore();


const useViewport = () => {
  const [width, setWidth] = React.useState(window.innerWidth);

  React.useEffect(() => {
    const handleWindowResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleWindowResize);
    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);

  // Return the width so we can use it in our components
  return {width};
};

const mapStateToProps = ({main}: any) => ({
  busData: main.busData,
  locations: main.locations,
  routeTags: main.routeTags,
  allEta: main.allEta,
  ntp: main.ntp,
  routeByIds: main.routeByIds,
  allAssignments: main.allAssignments,
});

const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators(
    {
      getBusETA,
      updateBusLocation,
      updateEta,
      shouldUpdateData,
      getRouteTags,
      getAllEta,
      getAllEtaSuccess,
      setNtp,
      setNtpSuccess,
      getAllAssignment,
    },
    dispatch
  );
};

const Main = connect(
  mapStateToProps,
  mapDispatchToProps
)(({busData, ...props}: any) => {
  const [activeIndex, setActiveIndex] = useState<number>(-1);
  const [locations, setLocations] = useState<any>([]);
  const lastSubscribedRouteIdsRef = useRef<string>('');
  const routeTagsMemo = useMemo(() => props.routeTags, [props.routeTags]);
  const locationsMemo = useMemo(() => locations, [locations]);
  const [isAllRoute, setIsAllRoute] = useState<boolean>(false);
  const [AllRoute, setAllRoute] = useState<any>(null);
  const [now, setNow] = useState<any>(null);
  const [routeFilterId, setRouteFilterId] = useState<number | null>(null);
  const [routeOverrideId, setRouteOverrideId] = useState<number | null>(null);

  // Initial assigning the diff of ntp value to current device time to the state
  useEffect(() => {
    getDateByNTP().then((time: any) => {
      const toMoment = moment(time.datetime);
      const diff = moment().diff(toMoment);
      const diffInMinutes = moment.duration(diff).asMinutes();

      props.setNtp(-diffInMinutes);
    });
  }, []);

  // Initial Setup. Register SignalR listeners, begin connection, and get Route Tags Data
  useEffect(() => {
    const unsubData = signalrService.subscribeData((data: any) => {
      props.updateBusLocation(data);
    });

    signalrService.start();
    props.getRouteTags();
    props.getAllAssignment();

    return () => {
      unsubData();
    };
  }, []);

  // Listen for Route Tags props changes. When changed, populate RouteID Data and set List of route to be subscribed. set to state.
  useEffect(() => {
    if (!props.routeTags || props.routeTags.length === 0) return;

    let tmpRouteFilterId = null;

    const routeToSub: RouteID[] = [];

    props.routeTags.forEach((routeTag: any) => {
      routeTag.routes.forEach((route: any) => {
        // Show all route point
        routeToSub.push({id: route.routeId, routeLocationIds: []});
      });
    });

    const routeKey = routeToSub
      .map((r) => r.id)
      .sort()
      .join(',');

    if (routeKey && routeKey !== lastSubscribedRouteIdsRef.current) {
      lastSubscribedRouteIdsRef.current = routeKey;
      setAllRoute(routeToSub);
      props.getBusETA(routeToSub);
      signalrService.setSubscribedRoutes(routeToSub.map((r: RouteID) => Number(r.id)));
    }

    setRouteFilterId(tmpRouteFilterId);
    setActiveIndex(0);
  }, [props.routeTags]);

  // Listen for the route tags and update the state
  useEffect(() => {
    if (AllRoute !== null && isAllRoute === false) {
      props.getAllEta(AllRoute);
      setIsAllRoute(() => true);
    }
  }, [AllRoute, isAllRoute]);

  // Listen for the route tags and update the state
  useEffect(() => {
    const activeRouteTags = props.routeTags[activeIndex];

    if (activeRouteTags) {
      const activeRouteIds = _.map(
        activeRouteTags.routes,
        (route) => route.routeId
      );

      let colorIndexSelector = 0;

      const displayLocations = _.filter(props.locations, (location) =>
        location.routeIds.some((o: Number) => activeRouteIds.includes(o))
      );

      displayLocations.forEach((displayLocation) => {
        displayLocation.color = colors[colorIndexSelector];
        colorIndexSelector++;

        const locationBusData = _.filter(
          busData,
          (o) =>
            o.toLocation.id === displayLocation.locationId &&
            activeRouteIds.includes(o.route.id)
        );

        displayLocation.busData = _.orderBy(locationBusData, (item: any) => {
          return moment(item.eta);
        });
      });

      setLocations(displayLocations);
    }
  }, [busData, activeIndex, props.locations]);

  // Use Effects
  useEffect(() => {
    const interval = setInterval(() => {
      setNow(moment().add(props.ntp, "minutes"));
    }, 1000);
    return () => clearInterval(interval);
  }, [locations, now]);

  // Check whether there's bus/schedule override going on
  // Override which mean if today was a weekday, then the bus took the weekend route
  useEffect(() => {
    props.routeByIds.forEach((route: any) => {
      if (route.vehicleEtas.length > 0) {
        setRouteOverrideId(route.routeId);
      }
    });
  }, [props.routeTags, props.routeByIds]);

  // Render the component
  return (
    <div className="App">
      <ComponentRender
        routeTagsMemo={routeTagsMemo}
        locationsMemo={locationsMemo}
        setActiveIndex={setActiveIndex}
        activeIndex={activeIndex}
        ntp={props.ntp}
        compareTime={now}
        routeFilterId={routeFilterId}
        routeOverrideId={routeOverrideId}
        allAssignments={props.allAssignments}
      />
    </div>
  );
});

// Render the component
const BusMarker = React.memo<any>(({remaining, color}: any) => {
  const getETA = useCallback(() => {
    if (remaining < 1 && remaining > 0.12) {
      return (
        <div
          className="Marker-ETA-Arriving"
          style={{backgroundColor: color}}
        >{`ARRIVING`}</div>
      );
    } else if (remaining <= 0.12) {
      return (
        <div
          className="Marker-ETA-Arr"
          style={{backgroundColor: color}}
        >{`ARRIVED`}</div>
      );
    } else {
      return (
        <div
          className="Marker-ETA"
          style={{backgroundColor: color}}
        >{`${Math.floor(remaining)}min`}</div>
      );
    }
  }, [color, remaining]);

  return (
    <div className="Marker-Wrapper">
      {getETA()}
      <img className="Marker-Icon" src={marker} alt="Bus Marker" />
    </div>
  );
});

// Render the component
export const FlagMarker = React.memo<any>((props: any) => {
  return (
    <div className="Marker-Wrapper-Flag">
      <div>
        <svg
          width="41"
          height="44"
          viewBox="0 0 41 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M41 20.5C41 31.8218 31.8218 41 20.5 41C9.17816 41 0 31.8218 0 20.5C0 9.17816 9.17816 0 20.5 0C31.8218 0 41 9.17816 41 20.5Z"
            fill={`${props.color ? props.color : "#016901"}`}
          />
          <path
            d="M21 44L24.4641 40.25H17.5359L21 44Z"
            fill={`${props.color ? props.color : "#016901"}`}
          />
          <g clipPath="url(#clip0)">
            <path
              d="M22.8125 19.0625H28.0625C28.304 19.0625 28.5 18.8665 28.5 18.625C28.5 18.3835 28.304 18.1875 28.0625 18.1875H22.8125C22.571 18.1875 22.375 18.3835 22.375 18.625C22.375 18.8665 22.571 19.0625 22.8125 19.0625Z"
              fill="white"
            />
            <path
              d="M28.9375 19.9375H21.9375C21.696 19.9375 21.5 20.1335 21.5 20.375V25.625C21.5 25.8665 21.696 26.0625 21.9375 26.0625H28.9375C29.179 26.0625 29.375 25.8665 29.375 25.625V20.375C29.375 20.1335 29.179 19.9375 28.9375 19.9375ZM28.5 25.1875H22.375V20.8125H28.5V25.1875H28.5Z"
              fill="white"
            />
            <path
              d="M31.5625 19.0625C31.321 19.0625 31.125 19.2585 31.125 19.5V18.625C31.125 17.4193 30.1432 16.4375 28.9375 16.4375H21.9375C20.7318 16.4375 19.75 17.4193 19.75 18.625V19.5C19.75 19.2585 19.554 19.0625 19.3125 19.0625C19.071 19.0625 18.875 19.2585 18.875 19.5V23C18.875 23.2415 19.071 23.4375 19.3125 23.4375C19.554 23.4375 19.75 23.2415 19.75 23V28.25C19.75 28.4915 19.946 28.6875 20.1875 28.6875H20.6251C20.6251 29.1696 21.0179 29.5625 21.5 29.5625H22.375C22.8572 29.5625 23.25 29.1696 23.25 28.6875H27.625C27.625 29.1696 28.0179 29.5625 28.5 29.5625H29.375C29.8571 29.5625 30.25 29.1696 30.25 28.6875H30.6875C30.929 28.6875 31.125 28.4915 31.125 28.25V23C31.125 23.2415 31.321 23.4375 31.5625 23.4375C31.804 23.4375 32 23.2415 32 23V19.5C32 19.2585 31.804 19.0625 31.5625 19.0625ZM30.25 27.8125H20.625V18.625C20.625 17.9013 21.2139 17.3125 21.9375 17.3125H28.9375C29.6612 17.3125 30.25 17.9013 30.25 18.625V27.8125H30.25Z"
              fill="white"
            />
            <path
              d="M15.8125 26.9374H14.0625C13.3389 26.9374 12.75 27.5262 12.75 28.2499V29.1249C12.75 29.3664 12.946 29.5624 13.1875 29.5624C13.429 29.5624 13.625 29.3664 13.625 29.1249V28.6874H16.25V29.1249C16.25 29.3664 16.446 29.5624 16.6875 29.5624C16.929 29.5624 17.125 29.3664 17.125 29.1249V28.2499C17.125 27.5263 16.5361 26.9374 15.8125 26.9374Z"
              fill="white"
            />
            <path
              d="M20.1875 15.5625C20.429 15.5625 20.625 15.3665 20.625 15.125V14.25C20.625 11.5961 18.4664 9.4375 15.8125 9.4375C13.1587 9.4375 11 11.5961 11 14.25V29.125C11 29.3665 11.196 29.5625 11.4375 29.5625C11.679 29.5625 11.875 29.3665 11.875 29.125V19.7572L19.4254 15.5625H20.1875ZM11.875 14.25C11.875 12.0791 13.6416 10.3125 15.8125 10.3125C17.9834 10.3125 19.75 12.0791 19.75 14.25V14.6875H11.875V14.25ZM11.875 18.7563V15.5625H17.6237L11.875 18.7563Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect
                width="21"
                height="21"
                fill="white"
                transform="translate(11 9)"
              />
            </clipPath>
          </defs>
        </svg>
      </div>
    </div>
  );
});

// Render the component
const ComponentRender = React.memo<any>(
  ({
    routeTagsMemo,
    locationsMemo,
    setActiveIndex,
    activeIndex,
    ntp,
    compareTime,
    routeOverrideId,
    routeFilterId,
    allAssignments,
  }: any) => {
    // States
    const [showModal, setShowModal] = useState(false);
    const [filteredRouteTags, setFilteredRouteTags] = useState([]);
    const [filteredLocations, setFilteredLocations] = useState<any[]>([]);
    const isWeekdayFromDate = (moment().day() !== 0 && moment().day() !== 6);
    const [mapModeFromAssignment, setMapModeFromAssignment] = useState<string | null>(null);
    const [mapModeFinal, setMapModeFinal] = useState<string | null>(null);
    const [isMapLoading, setIsMapLoading] = useState(true);
    const [isWeekdayFromAssignment, setIsWeekdayFromAssignment] = useState<boolean | null>(null);
    const [isMapFullyLoaded, setIsMapFullyLoaded] = useState(false);

    const routeTags = useMemo(() => {
      return routeTagsMemo;
    }, [routeTagsMemo]);
    const locations = useMemo(() => {
      return locationsMemo;
    }, [locationsMemo]);
    const {width} = useViewport();

    const handleApiLoadedWeekday = ({map, maps}: any) => {
      // Determine if it is weekday or weekend
      let polyString: string = atob(weekdayRoute);

      // Define the LatLng coordinates for the polyline's path
      const polylinePath = polyline.decode(polyString as string);

      const transformedCoordinates = polylinePath.map((coords: any) => ({
        lat: coords[0],
        lng: coords[1],
      }));

      // Create a new polyline using the Google Maps API
      const polylines = new maps.Polyline({
        path: transformedCoordinates,
        geodesic: true,
        strokeColor: "#2A6BEB",
        strokeOpacity: 1.0,
        strokeWeight: 3,
      });

      // Set the polyline on the map
      polylines.setMap(map);
    };
    const handleApiLoadedWeekend = ({map, maps}: any) => {
      // Determine if it is weekday or weekend
      let polyString: string = atob(weekendRoute);

      // Define the LatLng coordinates for the polyline's path
      const polylinePath = polyline.decode(polyString as string);

      const transformedCoordinates = polylinePath.map((coords: any) => ({
        lat: coords[0],
        lng: coords[1],
      }));

      // Create a new polyline using the Google Maps API
      const polylines = new maps.Polyline({
        path: transformedCoordinates,
        geodesic: true,
        strokeColor: "#2A6BEB",
        strokeOpacity: 1.0,
        strokeWeight: 3,
      });

      // Set the polyline on the map
      polylines.setMap(map);
    };

    const changeActiveIndex = useCallback(
      (index: number) => {
        setActiveIndex(
          index === activeIndex ? (width >= 1130 ? index : -1) : index
        );
      },
      [activeIndex, setActiveIndex, width]
    );

    useEffect(() => {
      setFilteredRouteTags(routeTags)
    }, [routeTags])

    useEffect(() => {
      // Don't reset filtered locations if map is already loaded
      if (isMapFullyLoaded === true) return;

      // Variables
      let tmpFilteredLocations: any[] = [];

      // Decide its Hardcoded weekend/weekdays or using override
      let tmpMapMode = 'hardcoded';

      // Check is there's an assignemnt exist 
      if (allAssignments === undefined) return;
      if (allAssignments.length > 0) {
        allAssignments.forEach((assignment: any) => {
          if (assignment.assignments.length > 0) {
            tmpMapMode = 'override';
            routeOverrideId = assignment.id;

            // Send log
            debugLog(LogLevel.INFO, 'Map overrided by existing assignment. ', {
              assignment: assignment,
            });
          }
        });
      }

      // Iterate
      // Mode: Override
      if (tmpMapMode === 'override') {
        locations.forEach((location: any) => {
          if (location.routeIds?.includes(routeOverrideId)) {
            tmpFilteredLocations.push(location);
          }
        });

        // Sort stops by the active route's order field so the sequence is correct.
        // Build a locationId→order map from the active route's routeLocations
        // (deduplication preserves the first-inserted route's order, not the active route's).
        const activeRouteData = allAssignments.find((a: any) => a.id === routeOverrideId);
        const orderMap: Record<number, number> = {};
        if (activeRouteData?.routeLocations) {
          activeRouteData.routeLocations.forEach((rl: any) => {
            if (!(rl.locationId in orderMap) || rl.order < orderMap[rl.locationId]) {
              orderMap[rl.locationId] = rl.order;
            }
          });
        }
        tmpFilteredLocations.sort((a: any, b: any) => {
          const orderA = orderMap[a.locationId] ?? Number.MAX_SAFE_INTEGER;
          const orderB = orderMap[b.locationId] ?? Number.MAX_SAFE_INTEGER;
          return orderA - orderB;
        });

        // Get the weekday/weekend — match directly against routeOverrideId
        // (not tmpFilteredLocations[0].routeId which may be from a different/older route)
        routeTagsMemo.forEach((routeTag: any) => {
          routeTag.routes.forEach((route: any) => {
            if (route.routeId === routeOverrideId) {
              if (route.route.name.includes('Weekday')) {
                setIsWeekdayFromAssignment(true);
              }
              if (route.route.name.includes('Weekend')) {
                setIsWeekdayFromAssignment(false);
              }
            }
          });
        });
      }

      if (tmpMapMode === 'hardcoded') {
        locations.forEach((location: any) => {
          // Mode: Hardcoded
          if (routeFilterId !== null) {
            if (routeFilterId === location.routeId) {
              tmpFilteredLocations.push(location);
            }
          }
        });
      }

      setMapModeFromAssignment(tmpMapMode);
      setFilteredLocations(tmpFilteredLocations);

    }, [locations, routeOverrideId, routeFilterId, routeTagsMemo, isMapFullyLoaded]);

    useEffect(() => {
      //
      if (mapModeFromAssignment === 'override') {
        // Reject if mode override but no assignment
        if (isWeekdayFromAssignment === null) {
          return;
        }


        if (isWeekdayFromAssignment === true) {
          setMapModeFinal('weekday');
        } else {
          setMapModeFinal('weekend');
        }

        // setIsMapLoading(false);
      }

      if (mapModeFromAssignment === 'hardcoded') {
        // 
        if (isWeekdayFromDate === null) {
          return;
        }

        if (isWeekdayFromDate === true) {
          setMapModeFinal('weekday');
        } else {
          setMapModeFinal('weekend');
        }

        // setIsMapLoading(false);
      }
    }, [isWeekdayFromAssignment, isWeekdayFromDate, mapModeFromAssignment]);


    // Show default map (based on current day) if more than timeout
    useEffect(() => {
      const timer = setTimeout(() => {
        // 
        if (isMapLoading === false) return;
        if (isMapFullyLoaded === true) return;

        // Send log
        debugLog(LogLevel.INFO, 'No active assignment found, showing default map based on date', {
          isMapLoading,
          isMapFullyLoaded,
        });

        // Get current day
        const isWeekday = moment().day() !== 0 && moment().day() !== 6;
        let currentRouteId: number | null = null;

        if (routeTagsMemo.length > 0) {
          if (routeTagsMemo[0].routes.length > 0) {

            routeTagsMemo[0].routes.forEach((route: any) => {
              if (isWeekday === true) {
                if (route.route.name.includes('Weekday') === true) {
                  currentRouteId = route.routeId;
                }
              } else {
                if (route.route.name.includes('Weekend') === true) {
                  currentRouteId = route.routeId;
                }
              }
            });
          }
        }

        // Inject stops to `filteredLocations`
        if (currentRouteId === null) return;
        let tmpFilteredLocations: any[] = [];
        locations.forEach((location: any) => {
          if (currentRouteId === location.routeId) {
            tmpFilteredLocations.push(location);
          }
        });

        // Mark loading eneded when all stops are injected
        if (tmpFilteredLocations.length > 0) {
          setFilteredLocations(tmpFilteredLocations);
          setIsMapFullyLoaded(true);
          setIsMapLoading(false);
        }

      }, 2000); // 2 sec

      return () => clearTimeout(timer);
    }, [locations, routeTagsMemo, isMapFullyLoaded, isMapLoading]);

    useEffect(() => {
      // Skip render map if item is empty
      if (filteredLocations.length < 1) return;

      setIsMapLoading(false);
    }, [filteredLocations]);

    return (
      <>
        {width >= 1130 ? (
          <header
            className="Navbar"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: "-30px",
            }}
          >
            <img className="Logo" src={wrs} alt="Logo" />
            <div style={{marginTop: "15px", marginRight: "5%"}}>
              <div
                className="Notice"
                style={{width: "400px", marginBottom: "10px"}}
              >
                <img
                  style={{height: "25px", marginRight: "10px"}}
                  alt="notice"
                  src={exclamation}
                />
                <span>
                  <b>Please note</b>: The color atop the bus icon signifies its
                  next stop. Please prepare accordingly.
                </span>
              </div>
              <div className="Notice" style={{width: "400px"}}>
                <img
                  style={{height: "25px", marginRight: "10px"}}
                  alt="notice"
                  src={exclamation}
                />
                <span>
                  <b>ETAs</b> may vary by <b>+/- 5 minutes</b>. Refresh every 3 minute for the latest updates.
                </span>
              </div>
            </div>
          </header>
        ) : (
          <header
            className="Navbar"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              margin: "25px",
            }}
          >
            <img
              className="Logo"
              src={wrs}
              alt="Logo"
              style={{marginBottom: "15px"}}
            />
            <div>
              <div
                className="Notice"
                style={{marginBottom: "10px", width: "100%"}}
              >
                <img
                  style={{height: "25px", marginRight: "10px"}}
                  alt="notice"
                  src={exclamation}
                />
                <span>
                  <b>Please note</b>: The color atop the bus icon signifies its
                  next stop. Please prepare accordingly.
                </span>
              </div>
              <div className="Notice" style={{width: "100%"}}>
                <img
                  style={{height: "25px", marginRight: "10px"}}
                  alt="notice"
                  src={exclamation}
                />
                <span>
                  <b>ETAs</b> may vary by <b>+/- 5 minutes</b>. Refresh every 3 minute for the latest updates.
                </span>
              </div>
            </div>
          </header>
        )}
        <div className="Wrapper">
          <div className="Selection-Wrapper">
            <h3 className="Route-Title">Shuttle Service</h3>
            {_.isEmpty(filteredRouteTags) ? (
              <div className="Title-Loading-Wrapper">
                <div className="lds-ellipsis">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            ) : (
              filteredRouteTags.map((item: any, index: number) => {
                return (
                  <div
                    key={item.id}
                    className={`Route-Button ${activeIndex === index ? "active" : ""
                      }  `}
                  >
                    <div
                      className="Button-Text-Wrapper"
                      onClick={() => {
                        changeActiveIndex(index);
                      }}
                    >
                      {item.name}
                      {activeIndex === index ? (
                        <img
                          alt="caret-active"
                          className="Caret-Icon"
                          src={caretActive}
                        />
                      ) : (
                        <img
                          alt="caret-inactive"
                          className="Caret-Icon"
                          src={caretInactive}
                        />
                      )}
                    </div>

                    {activeIndex === index && width < 1130 && (
                      <>
                        {/* Mobile View */}
                        <div className="Mini-Map">
                          {
                            isMapLoading === true && (
                              <>
                                <div className="lds-ellipsis">
                                  <div></div>
                                  <div></div>
                                  <div></div>
                                  <div></div>
                                </div>
                              </>
                            )
                          }
                          {
                            isMapLoading === false && (
                              <div>
                                {/* Weekday */}
                                <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', display: mapModeFinal === 'weekday' ? 'block' : 'none'}}>
                                  <GoogleMapReact
                                    bootstrapURLKeys={{key: googleMapsApi}}
                                    defaultCenter={weekdayCenterLocation}
                                    yesIWantToUseGoogleMapApiInternals
                                    onGoogleApiLoaded={handleApiLoadedWeekday}
                                    defaultZoom={
                                      activeIndex === 0 ?
                                        (weekdayZoom) :
                                        (weekdayZoom - 2)
                                    }
                                  >
                                    {filteredLocations?.map((location: any) => (
                                      <FlagMarker
                                        key={location.location.id}
                                        color={
                                          !_.isEmpty(location.busData)
                                            ? location.color
                                            : "#a6a6a6"
                                        }
                                        lat={location.location.lat}
                                        lng={location.location.lng}
                                      />
                                    ))}
                                    {filteredLocations.map((busLocation: any) => {
                                      const smallestEta = busLocation?.etas
                                        ?.filter((eta: any) => eta && eta.eta) // Exclude null or invalid eta entries
                                        ?.reduce((min: any, eta: any) => {
                                          if (min === null) return eta;
                                          return moment(eta.eta).isBefore(moment(min.eta))
                                            ? eta
                                            : min;
                                        }, null);
                                      return busLocation?.busData?.map((bus: any, i: number) => {
                                        const now = moment().add(ntp, "minutes");

                                        // Reject if null
                                        if (bus.vehicle === null) return <></>;
                                        if (compareTime === null) return <></>;

                                        const diff = compareTime.diff(moment(bus.vehicle?.expiredAt), "minutes");
                                        let adjustedETA = null;
                                        let remaining = null;
                                        if (smallestEta === null) {
                                          adjustedETA = moment(bus.eta);
                                          remaining = moment
                                            .duration(adjustedETA?.diff(now))
                                            .asMinutes();
                                        } else {
                                          adjustedETA = moment(smallestEta?.eta);
                                          remaining = moment
                                            .duration(adjustedETA.diff(now))
                                            .asMinutes();
                                        }

                                        if (!bus.hide && diff === 2) {
                                          return <></>;
                                        }

                                        if (!bus.hide && diff < 1) {
                                          return (
                                            <BusMarker
                                              remaining={remaining}
                                              color={busLocation.color}
                                              bus={bus}
                                              key={i}
                                              lat={bus?.vehicle?.lastLocationLat}
                                              lng={bus?.vehicle?.lastLocationLng}
                                            />
                                          );
                                        } else {
                                          return <></>;
                                        }
                                      });
                                    })}
                                  </GoogleMapReact>
                                </div>

                                {/* Weekend */}
                                <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', display: mapModeFinal === 'weekend' ? 'block' : 'none'}}>
                                  <GoogleMapReact
                                    bootstrapURLKeys={{key: googleMapsApi}}
                                    defaultCenter={weekendCenterLocation}
                                    yesIWantToUseGoogleMapApiInternals
                                    onGoogleApiLoaded={handleApiLoadedWeekend}
                                    defaultZoom={
                                      activeIndex === 0 ?
                                        (weekendZoom) :
                                        (weekendZoom - 2)
                                    }
                                  >
                                    {filteredLocations?.map((location: any) => (
                                      <FlagMarker
                                        key={location.location.id}
                                        color={
                                          !_.isEmpty(location.busData)
                                            ? location.color
                                            : "#a6a6a6"
                                        }
                                        lat={location.location.lat}
                                        lng={location.location.lng}
                                      />
                                    ))}
                                    {filteredLocations.map((busLocation: any) => {
                                      const smallestEta = busLocation?.etas
                                        ?.filter((eta: any) => eta && eta.eta) // Exclude null or invalid eta entries
                                        ?.reduce((min: any, eta: any) => {
                                          if (min === null) return eta;
                                          return moment(eta.eta).isBefore(moment(min.eta))
                                            ? eta
                                            : min;
                                        }, null);
                                      return busLocation?.busData?.map((bus: any, i: number) => {
                                        const now = moment().add(ntp, "minutes");

                                        // Reject if null
                                        if (bus.vehicle === null) return <></>;

                                        const diff = compareTime.diff(moment(bus.vehicle?.expiredAt), "minutes");
                                        let adjustedETA = null;
                                        let remaining = null;
                                        if (smallestEta === null) {
                                          adjustedETA = moment(bus.eta);
                                          remaining = moment
                                            .duration(adjustedETA?.diff(now))
                                            .asMinutes();
                                        } else {
                                          adjustedETA = moment(smallestEta?.eta);
                                          remaining = moment
                                            .duration(adjustedETA.diff(now))
                                            .asMinutes();
                                        }

                                        if (!bus.hide && diff === 2) {
                                          return <></>;
                                        }

                                        if (!bus.hide && diff < 1) {
                                          return (
                                            <BusMarker
                                              remaining={remaining}
                                              color={busLocation.color}
                                              bus={bus}
                                              key={i}
                                              lat={bus?.vehicle?.lastLocationLat}
                                              lng={bus?.vehicle?.lastLocationLng}
                                            />
                                          );
                                        } else {
                                          return <></>;
                                        }
                                      });
                                    })}
                                  </GoogleMapReact>
                                </div>
                              </div>
                            )
                          }
                        </div>
                        <div className="Route-Wrapper-Mini">
                          <div className="Route-Header">
                            <div className="Text-Wrapper">
                              <span className="Text-Title">Pick-up</span>
                              <div className="Column-Flex">
                                <span className="Text-Detail">Estimated</span>
                                <span className="Text-Detail">
                                  Time of Arrival
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="Route-Body">
                            {_.isEmpty(filteredLocations) ? (
                              <div className="Title-Loading-Wrapper">
                                <div className="lds-ellipsis">
                                  <div></div>
                                  <div></div>
                                  <div></div>
                                  <div></div>
                                </div>
                              </div>
                            ) : (
                              filteredLocations.map((location: any) => (
                                <div
                                  key={location.id}
                                  className="Text-Wrapper Border-Bottom"
                                >
                                  <span
                                    className="Segment-Color-Code"
                                    style={{
                                      backgroundColor: location.busData
                                        ? location.color
                                        : "#a6a6a6",
                                    }}
                                  ></span>
                                  <div className="Segment-Title-Wrapper">
                                    <span className="Segment-Title">
                                      {location.location.name}
                                    </span>
                                    <span className="Segment-Description">
                                      {location.location.description}
                                    </span>
                                  </div>
                                  {(() => {
                                    const now = moment().add(ntp, "minutes");
                                    let remaining: any = null;
                                    if (
                                      location &&
                                      Array.isArray(location.etas) &&
                                      location.etas.length > 0
                                    ) {
                                      // Find the smallest eta
                                      const smallestEta = location.etas
                                        .filter((eta: any) => eta && eta.eta && compareTime.diff(moment(eta.expiredAt), "minutes") < 1)
                                        .reduce((min: any, eta: any) => {
                                          if (min === null) return eta;
                                          return moment(eta.eta).isBefore(
                                            moment(min.eta)
                                          )
                                            ? eta
                                            : min;
                                        }, null);
                                      if (
                                        smallestEta &&
                                        smallestEta.eta !== null
                                      ) {
                                        remaining = moment
                                          .duration(
                                            moment(smallestEta.eta).diff(now)
                                          )
                                          .asMinutes();
                                      }
                                    }
                                    const checkIfExist = remaining;
                                    if (
                                      checkIfExist &&
                                      remaining < 1 &&
                                      remaining > 0.12
                                    ) {
                                      return (
                                        <span className="Text-Note">
                                          ARRIVING
                                        </span>
                                      );
                                    } else if (
                                      checkIfExist &&
                                      remaining <= 0.12
                                    ) {
                                      return (
                                        <span className="Text-Note">
                                          ARRIVED
                                        </span>
                                      );
                                    } else if (checkIfExist) {
                                      return (
                                        <span className="Text-Time">
                                          {Math.floor(remaining)}
                                          <span className="Text-Min">min</span>
                                        </span>
                                      );
                                    } else {
                                      return (
                                        <span className="Text-Time">
                                          <span className="Text-Min">
                                            No ETA
                                          </span>
                                        </span>
                                      );
                                    }
                                  })()}
                                </div>
                              ))
                            )}
                          </div>
                        </div>
                        <div className="Mailto-Wrapper">
                          <span>
                            For any inquiry or feedback, please email us at:
                          </span>{" "}
                          <a
                            className="Mailto-Link"
                            href="mailto:enquiry.sg@theelegantgroup.com"
                          >
                            enquiry.sg@theelegantgroup.com
                          </a>
                        </div>
                      </>
                    )}
                  </div>
                );
              })
            )}
          </div>

          {/* Desktop View */}
          {/* Only Show if layout is at least 1130px wide */}
          {width >= 1130 && (
            <div className="Map-Wrapper">
              <div
                style={{
                  height: "70vh",
                  width: "60%",
                  backgroundColor: "#fafafa",
                  position: 'relative',
                }}
              >





                {
                  isMapLoading === true && (
                    <>
                      <div className="lds-ellipsis">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </>
                  )
                }
                {
                  isMapLoading === false && (
                    <div>
                      {/* Weekday */}
                      <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', display: mapModeFinal === 'weekday' ? 'block' : 'none'}}>
                        <GoogleMapReact
                          bootstrapURLKeys={{key: googleMapsApi}}
                          defaultCenter={weekdayCenterLocation}
                          yesIWantToUseGoogleMapApiInternals
                          onGoogleApiLoaded={handleApiLoadedWeekday}
                          defaultZoom={
                            activeIndex === 0 ?
                              (weekdayZoom) :
                              (weekdayZoom - 2)
                          }
                        >
                          {filteredLocations?.map((location: any) => (
                            <FlagMarker
                              key={location.id}
                              color={
                                !_.isEmpty(location.busData)
                                  ? location.color
                                  : "#a6a6a6"
                              }
                              lat={location.location.lat}
                              lng={location.location.lng}
                            />
                          ))}

                          {filteredLocations.map((busLocation: any) => {
                            const smallestEta = busLocation?.etas
                              ?.filter((eta: any) => eta && eta.eta) // Exclude null or invalid eta entries
                              ?.reduce((min: any, eta: any) => {
                                if (min === null) return eta;
                                return moment(eta.eta).isBefore(moment(min.eta))
                                  ? eta
                                  : min;
                              }, null);
                            return busLocation?.busData?.map((bus: any, i: number) => {
                              const now = moment().add(ntp, "minutes");

                              // Reject if null
                              if (bus.vehicle === null) return <></>;
                              if (compareTime === null) return <></>;

                              const diff = compareTime.diff(moment(bus.vehicle?.expiredAt), "minutes");
                              let adjustedETA = null;
                              let remaining = null;
                              if (smallestEta === null) {
                                adjustedETA = moment(bus.eta);
                                remaining = moment
                                  .duration(adjustedETA?.diff(now))
                                  .asMinutes();
                              } else {
                                adjustedETA = moment(smallestEta?.eta);
                                remaining = moment
                                  .duration(adjustedETA.diff(now))
                                  .asMinutes();
                              }

                              if (!bus.hide && diff === 2) {
                                return <></>;
                              }

                              if (!bus.hide
                                && diff < 1
                              ) {
                                return (
                                  <BusMarker
                                    remaining={remaining}
                                    color={busLocation.color}
                                    bus={bus}
                                    key={i}
                                    lat={bus?.vehicle?.lastLocationLat}
                                    lng={bus?.vehicle?.lastLocationLng}
                                  />
                                );
                              } else {
                                return <></>;
                              }
                            });
                          })}
                        </GoogleMapReact>
                      </div>

                      {/* Weekend */}
                      <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', display: mapModeFinal === 'weekend' ? 'block' : 'none'}}>
                        <GoogleMapReact
                          bootstrapURLKeys={{key: googleMapsApi}}
                          defaultCenter={weekendCenterLocation}
                          yesIWantToUseGoogleMapApiInternals
                          onGoogleApiLoaded={handleApiLoadedWeekend}
                          defaultZoom={
                            activeIndex === 0 ?
                              (weekendZoom) :
                              (weekendZoom - 2)
                          }
                        >
                          {filteredLocations?.map((location: any) => (
                            <FlagMarker
                              key={location.id}
                              color={
                                !_.isEmpty(location.busData)
                                  ? location.color
                                  : "#a6a6a6"
                              }
                              lat={location.location.lat}
                              lng={location.location.lng}
                            />
                          ))}

                          {filteredLocations.map((busLocation: any) => {
                            const smallestEta = busLocation?.etas
                              ?.filter((eta: any) => eta && eta.eta) // Exclude null or invalid eta entries
                              ?.reduce((min: any, eta: any) => {
                                if (min === null) return eta;
                                return moment(eta.eta).isBefore(moment(min.eta))
                                  ? eta
                                  : min;
                              }, null);
                            return busLocation?.busData?.map((bus: any, i: number) => {
                              const now = moment().add(ntp, "minutes");

                              // Reject if null
                              if (bus.vehicle === null) return <></>;
                              if (compareTime === null) return <></>;

                              const diff = compareTime.diff(moment(bus.vehicle?.expiredAt), "minutes");
                              let adjustedETA = null;
                              let remaining = null;
                              if (smallestEta === null) {
                                adjustedETA = moment(bus.eta);
                                remaining = moment
                                  .duration(adjustedETA?.diff(now))
                                  .asMinutes();
                              } else {
                                adjustedETA = moment(smallestEta?.eta);
                                remaining = moment
                                  .duration(adjustedETA.diff(now))
                                  .asMinutes();
                              }

                              if (!bus.hide && diff === 2) {
                                return <></>;
                              }

                              if (!bus.hide
                                && diff < 1
                              ) {
                                return (
                                  <BusMarker
                                    remaining={remaining}
                                    color={busLocation.color}
                                    bus={bus}
                                    key={i}
                                    lat={bus?.vehicle?.lastLocationLat}
                                    lng={bus?.vehicle?.lastLocationLng}
                                  />
                                );
                              } else {
                                return <></>;
                              }
                            });
                          })}
                        </GoogleMapReact>
                      </div>
                    </div>
                  )
                }









              </div>
              <div className="Route-Wrapper">
                <div className="Route-Header">
                  <div className="Text-Wrapper">
                    <span className="Text-Title">Pick-up</span>
                    <span className="Text-Detail">
                      Estimated Time of Arrival
                    </span>
                  </div>
                </div>
                <div className="Route-Body">
                  {_.isEmpty(filteredLocations) ? (
                    <div className="Title-Loading-Wrapper">
                      <div className="lds-ellipsis">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  ) : (
                    filteredLocations.map((location: any) => {
                      return (
                        <div className="Text-Wrapper Border-Bottom" key={location.id}>
                          <span
                            className="Segment-Color-Code"
                            style={{
                              backgroundColor: location.busData
                                ? location.color
                                : "#a6a6a6",
                            }}
                          ></span>
                          <div className="Segment-Title-Wrapper">
                            <span className="Segment-Title">

                              {location.location.name}
                            </span>
                            <span className="Segment-Description">
                              {location.location.description}
                            </span>
                          </div>
                          {(() => {
                            const now = moment().add(ntp, "minutes");
                            let remaining: any = null;
                            if (
                              location &&
                              Array.isArray(location.etas) &&
                              location.etas.length > 0
                            ) {
                              // Find the smallest eta
                              const smallestEta = location.etas
                                .filter((eta: any) => eta && eta.eta && compareTime.diff(moment(eta.expiredAt), "minutes") < 1)
                                .reduce((min: any, eta: any) => {
                                  if (min === null) return eta;
                                  return moment(eta.eta).isBefore(
                                    moment(min.eta)
                                  )
                                    ? eta
                                    : min;
                                }, null);

                              if (
                                smallestEta &&
                                smallestEta.eta !== null
                              ) {
                                remaining = moment
                                  .duration(moment(smallestEta.eta).diff(now))
                                  .asMinutes();
                              }

                            } else {
                              remaining = null;
                            }
                            const checkIfExist = remaining;
                            if (
                              checkIfExist &&
                              remaining < 1 &&
                              remaining > 0.12
                            ) {
                              return (
                                <span className="Text-Note">ARRIVING</span>
                              );
                            } else if (checkIfExist && remaining <= 0.12) {
                              return <span className="Text-Note">ARRIVED</span>;
                            } else if (checkIfExist) {
                              return (
                                <span className="Text-Time">
                                  {Math.floor(remaining)}
                                  <span className="Text-Min">min</span>
                                </span>
                              );
                            } else {
                              return (
                                <span className="Text-Time">
                                  <span className="Text-Min">No ETA</span>
                                </span>
                              );
                            }
                          })()}
                        </div>
                      );
                    })
                  )}
                </div>
                <div className="Mailto-Wrapper">
                  <span>For any inquiry or feedback, please email us at:</span>{" "}
                  <a
                    className="Mailto-Link"
                    href="mailto:enquiry.sg@theelegantgroup.com"
                  >
                    enquiry.sg@theelegantgroup.com
                  </a>
                </div>
              </div>
            </div>
          )}
          <div className="Logo-Wrapper">
            <div className="Logo-Container">
              <div className="Plotigo-Wrapper">
                <p>Powered by</p>
                <section>
                  <a href="https://www.plotigo.app/">
                    <img
                      className="Plotigo-Logo"
                      src={plotigoLogo}
                      alt="plotigo-logo"
                    />
                  </a>
                </section>
              </div>
              <div className="Wt-Wrapper">
                {width > 1130 ? <><p>|</p> <p> Operated by</p></> : <p>Operated by</p>}
                <section className="Wt-Wrapper">
                  <a href="https://www.woodlandstransport.com.sg/">
                    <img className="Wt-Logo" src={wtLogo} alt="wt-logo" />
                  </a>
                </section>
              </div>
            </div>
          </div>
          {showModal && (
            <div className="Modal">
              <div className="Modal-Content">
                <div
                  onClick={() => {
                    setShowModal((state) => !state);
                  }}
                  className="CloseButton"
                >
                  <img alt="close" className="Close-Icon" src={closeIcon} />
                </div>
                <iframe
                  className="Modal-Iframe"
                  src="https://form.jotform.com/woodlandstransport/mandai-express"
                  title="description"
                ></iframe>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
);

const App = () => {
  return (
    <Provider store={store}>
      <Main />
    </Provider>
  );
};

export default React.memo(App);
